import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthLayout, Field } from "./Login";
import { useAuth, homeForRole } from "@/context/AuthContext";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

export default function CompleteProfile() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [f, setF] = useState({
    first_name: "", last_name: "", birthdate: "", phone: user?.phone || "",
  });
  const [busy, setBusy] = useState(false);
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.put("/auth/complete-profile", f);
      setUser(data);
      toast.success("Profil complété, bienvenue !");
      navigate(homeForRole(data.role), { replace: true });
    } catch (err) { toast.error(apiError(err)); }
    finally { setBusy(false); }
  };

  return (
    <AuthLayout title="Complétez votre profil" subtitle="Encore quelques informations pour finaliser votre compte">
      <form onSubmit={submit} className="space-y-4" data-testid="complete-profile-form">
        <Field label="Prénom(s)" value={f.first_name} onChange={set("first_name")} testid="cp-first" />
        <Field label="Nom" value={f.last_name} onChange={set("last_name")} testid="cp-last" />
        <Field label="Date de naissance" type="date" value={f.birthdate} onChange={set("birthdate")} testid="cp-birthdate" required={false} />
        <Field label="Téléphone" type="tel" value={f.phone} onChange={set("phone")} testid="cp-phone" required={false} placeholder="+228 ..." />
        <button disabled={busy} className="w-full bg-[#C85A32] text-white font-bold py-3 rounded-lg disabled:opacity-50" data-testid="cp-submit">{busy ? "..." : "Terminer"}</button>
      </form>
    </AuthLayout>
  );
}
